module.exports = __webpack_public_path__ + "static/media/federico-beccari.86552d30.jpg";